import { tap, map, Observable } from 'rxjs';

import { inject, signal, Injectable } from '@angular/core';

import { ChildApiService } from './child-api.service';

import { Child, UpdateChild, ChildRequestParams } from '@/app/entities';

import { ApiResponseNonNull } from '@/app/shared/http';

@Injectable({
  providedIn: 'root',
})
export class ChildStore {
  private childApiService = inject(ChildApiService);

  private _children = signal<Child[] | null>(null);
  readonly children = this._children.asReadonly();
  private _activeChild = signal<Child | null>(null);
  readonly activeChild = this._activeChild.asReadonly();

  getChildren(params: ChildRequestParams): Observable<ApiResponseNonNull<Child[]>> {
    return this.childApiService.getChildren(params).pipe(tap((res) => this._children.set(res.data)));
  }

  getChildById(id: number): Observable<Child> {
    return this.childApiService.getChildById(id).pipe(
      map((res) => res.data),
      tap((child) => this._activeChild.set(child)),
    );
  }

  updateChild(child: UpdateChild, childId: number): Observable<ApiResponseNonNull<Child>> {
    return this.childApiService.updateChild(child, childId).pipe(
      tap((res) => {
        const updatedChild = res.data;
        this._children.update((children) =>
          children ? children.map((p) => (p.id === updatedChild.id ? updatedChild : p)) : children,
        );

        this._activeChild.update((activeChild) => this.updateActiveChildUsers(activeChild, updatedChild));
      }),
    );
  }

  private updateActiveChildUsers(activeChild: Child | null, updatedChild: Child): Child | null {
    if (!activeChild) {
      return activeChild;
    }
    if (activeChild?.id === updatedChild.id) {
      return updatedChild;
    }

    return {
      ...activeChild,
      familyMembers: {
        ...activeChild.familyMembers,
        childUsers: activeChild.familyMembers.childUsers.map((user) =>
          user.id === updatedChild.id ? updatedChild : user,
        ),
      },
    };
  }
}
